import React from 'react';
import { Card, Table, Segmented } from 'antd';
import type { WorkstationControlCenterQueryParams } from '@/services/workstationControlCenter.service';
import { useWccTimeline } from '@/hooks/useWorkstationControlCenter';

interface Props {
  params: WorkstationControlCenterQueryParams;
  onPeriodChange: (p: 'today' | 'week' | 'month') => void;
}

const WorkstationTimeline: React.FC<Props> = ({ params, onPeriodChange }) => {
  const { data, isLoading } = useWccTimeline(params);
  const events = (data as { events?: Record<string, unknown>[] })?.events ?? [];

  return (
    <Card
      id="timeline"
      title="Production timeline (workstation-centric)"
      extra={
        <Segmented
          size="small"
          value={params.period || 'week'}
          onChange={(v) => onPeriodChange(v as 'today' | 'week' | 'month')}
          options={[
            { label: 'Day', value: 'today' },
            { label: 'Week', value: 'week' },
            { label: 'Month', value: 'month' },
          ]}
        />
      }
      style={{ marginTop: 16 }}
    >
      <Table
        size="small"
        loading={isLoading}
        rowKey={(_, i) => String(i)}
        dataSource={events}
        columns={[
          { title: 'Date', dataIndex: 'date', width: 110 },
          { title: 'Workstation', dataIndex: 'workstation_name' },
          { title: 'WO', dataIndex: 'work_order_number', width: 100 },
          { title: 'Operation', dataIndex: 'operation' },
          { title: 'Unit', dataIndex: 'unit_number', width: 60 },
          { title: 'Status', dataIndex: 'status' },
          { title: 'Kind', dataIndex: 'kind', width: 80 },
        ]}
        pagination={{ pageSize: 20 }}
      />
    </Card>
  );
};

export default WorkstationTimeline;
